import { defineMessages } from 'react-intl-next';

export const messages: {
	sectionLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	sectionLabel: {
		id: 'company-hub.company-hub-common.link-cards.card.image.section.label',
		defaultMessage: 'Image',
		description: 'Visible label for the section of the card for handling image',
	},
});
